module.exports = __webpack_public_path__ + "static/media/fundis-success-story-banner.4b165ad0.webp";